<script setup lang="ts">
    import { PlusIcon } from '@lucide/vue';

    defineEmits(['openForm']);

    const props = withDefaults(
        defineProps<{
            isNewDashboard?: boolean;
        }>(),
        { isNewDashboard: true }
    );
</script>
<template>
    <div
        :class="!props.isNewDashboard ? 'h-[125px] mt-6' : 'h-full'"
        class="flex items-center justify-center cursor-pointer hover:bg-gray-100 border border-dashed border-gray-light bg-white rounded-lg"
        @click="$emit('openForm')"
    >
        <div class="Drag__pan hidden" />
        <span class="p-4 border rounded-full text-gray-light">
            <PlusIcon class="size-10" />
        </span>
    </div>
</template>
